// imutable
import { Record } from 'immutable';

const MAX_FILE_SIZE = 64 * 1024 * 1024; // 64MB in bytes

export function checkFiles(dict, current) {
  return dict.includes(current);
}

export function checkFileSize(fileSize) {
  return fileSize <= MAX_FILE_SIZE;
}

export const SelectedCategoryLabelFactory = new Record({
  id: '',
  defaultMessage: '',
});

export const SelectedCategoryFactory = new Record({
  label: new SelectedCategoryLabelFactory(),
  value: null,
});

export const selectedCategoryAdapter = ({ label, ...rest }) =>
  SelectedCategoryFactory({
    label: SelectedCategoryLabelFactory(label),
    ...rest,
  });
